export const environment = {
  production: false,
  //APIURL: 'http://localhost:3000/api/',
  APIURL: 'https://api.tradnary.com/api/',
};
